import { render, staticRenderFns } from "./HJ0041.vue?vue&type=template&id=afd5045a&scoped=true&"
import script from "./HJ0041.vue?vue&type=script&lang=js&"
export * from "./HJ0041.vue?vue&type=script&lang=js&"
import style0 from "./HJ0041.vue?vue&type=style&index=0&id=afd5045a&prod&lang=less&scoped=true&"
import style1 from "./HJ0041.vue?vue&type=style&index=1&id=afd5045a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd5045a",
  null
  
)

export default component.exports